export function getAge(dateString) {
    let now = new Date()
    let birthday = new Date(dateString)
    let age = now.getFullYear() - birthday.getFullYear()
    let diferenciaMeses = now.getMonth() - birthday.getMonth()
    if (
        diferenciaMeses < 0 ||
        (diferenciaMeses === 0 && now.getDate() < birthday.getDate())
    ) {
        age--
    }
    return age;
}


export const toUTCString = (date) => {
    return date.toISOString().replace('T', ' ').substr(0, 19);
};

export const formatDateLocal = (stringDate, monthValue = 'short') => {
    let formatedDate = '';
    if (stringDate) {
        try {
            formatedDate = new Date(`${stringDate}Z`).toLocaleDateString( /* 'en-US', 'es-CO',*/undefined, {
                day: 'numeric',
                month: monthValue,
                year: 'numeric',
            });
        } catch (error) { }
    }
    return formatedDate;
};

export const formatTimeLocal = (stringTime) => {
    let formatedDate = '';
    if (stringTime) {
        try {
            formatedDate = new Date(`${stringTime}Z`).toLocaleTimeString({
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        } catch (error) { }
    }
    return formatedDate;
};


export const countdown = ({ date, days }) => {

    function sumarDias(date, dias) {
        const fecha = new Date(date)
        fecha.setDate(fecha.getDate() + dias)
        return fecha;

    }

    const auxDate = sumarDias(date, days)
    const difference = new Date(auxDate) - new Date(toUTCString(new Date()));

    if (difference > 0) {

        return <p><span>{Math.floor(difference / (1000 * 60 * 60 * 24))}d</span> <span>{Math.floor((difference / (1000 * 60 * 60)) % 24)}h</span> <span>{Math.floor((difference / 1000 / 60) % 60)}m</span> {/* <span>{Math.floor((difference / 1000) % 60)}s</span> */}
        </p>

    };
}


export const fromUTCtoLocal = (stringDate) => {

    const fechaUTC = new Date(stringDate);

    // Paso 2: Obtener la diferencia en minutos entre la zona horaria local y UTC
    const diferenciaZonaHoraria = fechaUTC.getTimezoneOffset();

    // Paso 3: Obtener la fecha y hora local
    const anioLocal = fechaUTC.getFullYear();
    const mesLocal = fechaUTC.getMonth();
    const diaLocal = fechaUTC.getDate();
    const horaLocal = fechaUTC.getHours();
    const minutosLocal = fechaUTC.getMinutes();
    const segundosLocal = fechaUTC.getSeconds();

    // Paso 4: Ajustar la fecha y hora usando la diferencia de zona horaria
    const fechaLocal = new Date(anioLocal, mesLocal, diaLocal, horaLocal, minutosLocal - diferenciaZonaHoraria, segundosLocal);

    return fechaLocal;
};

export const newFormat = (bddate) => {
    const date = new Date(fromUTCtoLocal(bddate));
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = date.toLocaleDateString(undefined, options);
    return formattedDate;
}

